import React, { useEffect, Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  fetchAuditLoginEvents,
  fetchHttpTraces,
  reset,
} from '../../actions/adminPanel';
import { locationPath } from '../../constants/app-routes';
import withTranslations from '../../utils/HighOrderComponent';
import AuditEventsTable from '../AuditEvents/AuditEventsTable';
import { tableConfig as auditLoginEventsTableConfig } from '../AuditEvents/auditLoginEventsTableConfig';
import { tableConfig as httpTraceTableConfig } from '../AuditEvents/httpTraceTableConfig';
import { notificationType } from '../../constants/globals';
import { createNotification } from '../../utils';
import { formatDate } from '../../utils/date';

const AuditEvents = (props) => {
  const { t } = props || {},
    { Table } = t || {},
    { Filters } = Table || {},
    { NotificationMessages } = Filters || {};
  const dispatch = useDispatch();
  const location = useLocation();
  const [postData, setPostData] = useState(null);
  const [auditEventsFiltered, setAuditEventsFiltered] = useState(null);

  const { auditLoginEvents, httpTraces } = useSelector(
    (state) => state.adminPanelReducer
  );
  const auditLoginEventsActionHandler = useCallback(() => {
    dispatch(fetchAuditLoginEvents());
  }, [dispatch]);

  const httpTraceActionHandler = useCallback(() => {
    dispatch(fetchHttpTraces());
  }, [dispatch]);

  const onSearchHandler = useCallback(
    function (searchData) {
      let auditEventsFiltered = auditLoginEvents;
      searchData.searchFilter?.forEach((searchFilter) => {
        if (searchFilter.property === 'timestamp') {
          auditEventsFiltered = auditEventsFiltered?.filter(
            (item) =>
              formatDate(item.timestamp) === formatDate(searchFilter.value)
          );
        } else if (searchFilter.property === 'type') {
          auditEventsFiltered = auditEventsFiltered?.filter(
            (item) => item.type.trim() === searchFilter.value.trim()
          );
        }
        setAuditEventsFiltered(auditEventsFiltered);
      });
      if (auditEventsFiltered.length === 0) {
        createNotification(
          notificationType.info,
          null,
          NotificationMessages.notFoundMessage
        );
      }
    },
    [auditLoginEvents, NotificationMessages]
  );

  useEffect(() => {
    location.pathname === locationPath.AUDIT_LOGIN_EVENTS
      ? auditLoginEventsActionHandler()
      : httpTraceActionHandler();
    return () => {
      dispatch(reset());
      setPostData(null);
    };
  }, [
    dispatch,
    location.pathname,
    auditLoginEventsActionHandler,
    httpTraceActionHandler,
  ]);

  useEffect(() => {
    postData && onSearchHandler(postData);
  }, [dispatch, postData, onSearchHandler]);

  return (
    <Fragment>
      {location.pathname === locationPath.AUDIT_LOGIN_EVENTS && (
        <Fragment>
          <AuditEventsTable
            t={Table}
            tableConfig={auditLoginEventsTableConfig}
            eventList={postData ? auditEventsFiltered : auditLoginEvents}
            tableTitle={Table.loginTitle}
            actionOnClick={auditLoginEventsActionHandler}
          />
        </Fragment>
      )}
      {location.pathname === locationPath.AUDIT_HTTP_TRACE && (
        <AuditEventsTable
          t={Table}
          tableConfig={httpTraceTableConfig}
          eventList={httpTraces}
          tableTitle={Table.httpTraceTitle}
          actionOnClick={httpTraceActionHandler}
        />
      )}
    </Fragment>
  );
};

export default withTranslations(AuditEvents, 'AuditEventsPage');
